import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";

import Spinner from "../../../../shared/components/spinner/spinner";
import TextInput from "../../../../shared/components/text-input/text-input";
import AuthContext from "../../../../shared/context/auth-context";
import { IEnumerationOption } from "../../../../shared/definitions/datatypes";
import useHttp from "../../../../shared/hooks/use-http";
import { getAllData } from "../../../../shared/utils/api";
import { IObject, validateLoadingStatusNew } from "../../../../shared/utils/utils";
import SearchInput from "../../../components/search-input/search-input";

export interface IScreenSetupData {
  name: string;
  event: string;
  event_id: string;
  alertcase_id: string;
}

interface IScreenSetupConfig {
  screenData: IScreenSetupData;
  handleDataChange: (newData: IScreenSetupData) => void;
}

const ScreenSetup = ({screenData, handleDataChange}: IScreenSetupConfig) => {
  const authCtx = useContext(AuthContext);
  const params = useParams();

  const [data, setData] = useState<IScreenSetupData>({
    name: "",
    event: "",
    event_id: "",
    alertcase_id: ""
  });
  const [allEvents, setAllEvents] = useState<IEnumerationOption[]>([]);
  
  const { sendRequest: getAllEvents, status: getAllEventsStatus, data: allEventData, error: getEventError } = useHttp(getAllData, true, authCtx.token, undefined, "manager");
  
  useEffect(() => {
    getAllEvents("available_datamodels/event");
  }, []);

  useEffect(() => {
    setData(screenData);
  }, [screenData]);

  useEffect(() => {
    if (params.id && screenData.event_id) {
      setAllEvents([{
        id: screenData.event_id,
        name: screenData.event
      }]);
    }
  }, [screenData]);

  useEffect(() => {
    if (allEventData && !getEventError && getAllEventsStatus === "completed") {
      setData({
        ...data,
        alertcase_id: allEventData.alertcase_id
      });

      setAllEvents(allEventData.rows.map((row: IObject) => ({
        id: row.id,
        name: row.name
      })));
    }
  }, [getAllEventsStatus, allEventData, getEventError]);

  const handleOnNameChange = (newValue: string) => {
    data.name = newValue;
    setData({...data});
    handleDataChange({...data});
  };

  const handleOnEventSelect = (selectedEvent: IEnumerationOption | undefined) => {
    if (!selectedEvent) {
      data.event = "";
      data.event_id = "";
      data.alertcase_id = "";
    } else {
      data.event = selectedEvent.name;
      data.event_id = selectedEvent.id;
    }
    
    setData({...data});
    handleDataChange({...data});
  };

  return <div>
    {validateLoadingStatusNew([getAllEventsStatus]) && <Spinner />}
    <div className="captureScreen-nameInput">
      <TextInput
        type={"text"}
        id={"name"}
        label={"Screen Name"}
        autofocus={false}
        required={true}
        inputKey={"name"}
        handleOnChange={handleOnNameChange}
        controlled={true}
        value={data.name}
      />
    </div>
    <div className="eventDropdown">
      <SearchInput
        label={"Event"}
        handleOnChange={handleOnEventSelect}
        data={allEvents}
        selectedOption={data.event_id}
        inputKey="event"
        required={true}
        readonly={!!params.id}
      />
    </div>
  </div>;
};

export default ScreenSetup;